import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDDialogActions, FDDialogContent, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import MetaLayoutVertical from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutVertical';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';
import ResendButtonPicker from './ResendButtonPicker';


function ChallengeSMSLayout() {
  const { resource, onSubmit, saving } = useMetaLayoutContext();

  return (
    <>
      <MetaControlField attr={'title'} />
      <FDDialogContent>
        <FDStack direction={'column'} justifyContent={'center'} alignItems={'stretch'} spacing={2} {...dataAttrs('dicrs-challenge-sms-layout')}>
          <MetaControlField attr={'primaryText'} />
          <MetaControlField attr={'sentTo'} />
          <MetaLayoutVertical resource={resource} />
          <ResendButtonPicker saving={saving} />
        </FDStack>
      </FDDialogContent>
      <FDDialogActions>
        <FDPrimaryActionButton
          label={'Continue'}
          onClick={onSubmit}
          test={'dicrs-challenge-sms-layout-submit-button'}
          loading={saving}
        />
      </FDDialogActions>
    </>
  );
}

ChallengeSMSLayout.propTypes = {
};

ChallengeSMSLayout.defaultProps = {
};

export default ChallengeSMSLayout;
